import { MethodPaymentType } from "@prisma/client";

export type MethodPayment = MethodPaymentType | "card";

export const methodPayments = ["card", "transfer", "bankDraft"] as const satisfies readonly MethodPayment[];

type MethodPaymentLabelVariant = "full" | "short";

const methodPaymentLabels: Record<MethodPaymentLabelVariant, Record<MethodPayment, string>> = {
  full: {
    card: "Carte bancaire",
    transfer: "Virement",
    bankDraft: "Chèque",
  },
  short: {
    card: "CB",
    transfer: "Virement",
    bankDraft: "Chèque",
  },
};

export function getMethodPaymentLabel(
  payment: MethodPayment,
  variant: MethodPaymentLabelVariant = "full",
) {
  return methodPaymentLabels[variant][payment];
}

export function getMethodPaymentDescription(payment: MethodPayment) {
  switch (payment) {
    case "transfer":
      return "Déblocage des prestations dès réception du versement.";
    case "bankDraft":
      return "Déblocage des prestations dans un délai de 15 jours calendaires après encaissement de la pièce.";
    default:
      return null;
  }
}

export function isMethodPayment(value: unknown): value is MethodPayment {
  return typeof value === "string" && (methodPayments as readonly string[]).includes(value);
}
